import { PureComponent } from "react";
import { StyledCarouselRoundArrowComponent } from "./carousel-round-arrow-component.scss";
import classnames from "classnames";

export default class CarouselRoundArrowComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, style, onClick } = this.props;
    return (
      <StyledCarouselRoundArrowComponent className={classnames(className, "carousel-round-arrow")} onClick={onClick}/>
    );
  }
}
